<template>
  <div class="content_box">
    <div class="moudule_box">
      <p class="item_title">为您推荐</p>
      <ul class="item_list">
        <li @click="toRecharge">
          <p class="item_list_img shjf" style="background-position:-1.1rem 0"></p>
          <div class="item_list_content">充值缴费</div>
        </li>
        <li @click="actingCapture">
          <p class="item_list_img shjf" style="background-position:-2.2rem 0"></p>
          <div class="item_list_content">代缴电费</div>
        </li>
        <li @click="toHistory">
          <p class="item_list_img shjf" style="background-position:0 0rem"></p>
          <div class="item_list_content">最新账单</div>
        </li>
        <li @click="toElectricityHistory">
          <p class="item_list_img shjf" style="background-position:-3.85rem 0"></p>
          <div class="item_list_content">用电趋势</div>
        </li>
        <li @click="toBill">
          <p class="item_list_img shjf" style="background-position:-1.65rem 0"></p>
          <div class="item_list_content">缴费记录</div>
        </li>
        <li @click="accountList">
          <p class="item_list_img wdda" style="background-position:-0rem 0"></p>
          <div class="item_list_content">户号管理</div>
        </li>
      </ul>
    </div>

    <div class="moudule_box">
      <p class="item_title">用电缴费</p>
      <ul class="item_list">
        <li @click="toRecharge">
          <p class="item_list_img shjf" style="background-position:-1.1rem 0"></p>
          <div class="item_list_content">充值缴费</div>
        </li>
        <li @click="actingCapture">
          <p class="item_list_img shjf" style="background-position:-2.2rem 0"></p>
          <div class="item_list_content">代缴电费</div>
        </li>
        <li @click="toHistory">
          <p class="item_list_img shjf" style="background-position:0 0rem"></p>
          <div class="item_list_content">最新账单</div>
        </li>
        <li @click="toBill">
          <p class="item_list_img shjf" style="background-position:-1.65rem 0"></p>
          <div class="item_list_content">缴费记录</div>
        </li>
        <li @click="toElectricityHistory">
          <p class="item_list_img shjf" style="background-position:-3.85rem 0"></p>
          <div class="item_list_content">用电趋势</div>
        </li>
        <li @click="toYcfd">
          <p class="item_list_img wdda" style="background-position:-0.55rem 0"></p>
          <div class="item_list_content">远程复电</div>
        </li>
      </ul>
    </div>

    <div class="moudule_box">
      <p class="item_title">停复电</p>
      <ul class="item_list">
        <li @click="toYcfd">
          <p class="item_list_img wdda" style="background-position:-0.55rem 0"></p>
          <div class="item_list_content">远程复电</div>
        </li>
        <li @click="notOpen">
          <p class="item_list_img tfd" style="background-position:-0rem 0"></p>
          <div class="item_list_content">停电公告</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
Vue.use(Icon);
import { Notify } from "vant";
import { queryBindConsNoList } from "@/api/user.js";
export default {
  data() {
    return {
      actions: [],
      url: config.url,
      isbindCount: false,
      appId: config.appId
    };
  },
  created() {
    this.queryBindConsNoList();
  },
  methods: {
    notOpen() {
      Notify("功能暂未开放，尽请期待");
    },
    queryBindConsNoList() {
      this.actions = [];
      queryBindConsNoList().then(res => {
        if (res.data.status == 200) {
          this.actions = res.data.object;
          if (res.data.object && res.data.object.length > 0) {
            this.isbindCount = true;
          } else {
            this.isbindCount = false;
          }
        }
      });
    },
    toRecharge() {
      if (this.isbindCount) {
        let consId = this.actions[0].consId;
        this.$router.push({
          path: `/tcmr/WxRecharge?state=${consId}`
        });
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    },
    actingCapture() {
        // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        //   this.appId
        // }&redirect_uri=${encodeURIComponent(this.url)}${encodeURIComponent(
        //   "tcmr/actingCapture"
        // )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
        this.$router.push({
          path: `/tcmr/actingCapture`
        });
    },
    toHistory() {
      if (this.isbindCount) {
        let consId = this.actions[0].consId;
        this.$router.push({
          path: `/tcmr/history?consId=${consId}`
        });
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    },
    toElectricityHistory() {
      if (this.isbindCount) {
        let consId = this.actions[0].consId;
        this.$router.push({
          path: `/tcmr/electricityHistory?consId=${consId}`
        });
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    },
    toBill() {
      if (this.isbindCount) {
        let consId = this.actions[0].consId;
        this.$router.push({
          path: `/tcmr/paymentRecords?consId=${consId}`
        });
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    },
    accountList() {
      this.$router.push({
        path: `/tcmr/accountList`
      });
    },
    toYcfd() {
      if (this.isbindCount) {
        let consId = this.actions[0].consId;
        this.$router.push({
          path: `/tcmr/ycfd?consId=${consId}`
        });
      } else {
        this.$router.push({
          path: `/tcmr/bindAccount`
        });
      }
    }
  }
};
</script>

<style scoped>
.content_box {
  text-align: left;
}

.moudule_box {
  overflow: hidden;
  border-bottom: 0.18rem solid #f7f8fa;
}

.item_title {
  margin: 0.31rem;
  font-size: 0.25rem;
}



.item_list li {
  float: left;
  font-size: 0;
  width: 1.55rem;
  text-align: center;
}

.item_list_img {
  margin: 0;
  display: inline-block;
  width: 0.57rem;
  height: 0.4rem;
  background-repeat: no-repeat;
  background-size: auto 0.45rem;
}

.shjf {
  background-image: url(../assets/mudule_bg.png);
}

.item_list_content {
  margin-top: 0.19rem;
  margin-bottom: 0.5rem;
  font-size: 0.23rem;
  color: #595959;
  line-height: 0.2rem;
}

.wdda {
  background-image: url(../assets/wdda.png);
}

.tfd {
  background-image: url(../assets/tfd.png);
}
</style>